import React from "react";
import ReactImage from "/@src/components/newComponents/ReactImage";
import VideoPlayer from "/@src/components/common/VideoPlayer";
import { getMedia } from "/@src/constants/mediaTypes";
import { rewriteMediaUrl } from "/@src/helpers/Utils";

function RenderMedia({
  altText = "",
  url,
  mimeType = "",
  type = "",
  placeholder = "",
  mediaStyles,
  videoType = "video/mp4",
  videoControls = true,
  videoAutoplay = false,
}) {
  const renderMedia = () => {
    let typeValue = type;
    let media = {};
    media = getMedia(url, mimeType, type);
    typeValue = media?.type;

    let placholderSrc = placeholder;
    if (!placeholder) {
      placholderSrc = media.placeholderImage;
    }
    
    const mediaUrl = rewriteMediaUrl(url);

    switch (typeValue) {
      case "image":
        return (
          <ReactImage
            alt={altText}
            style={{ maxWidth: "100%", ...mediaStyles }}
            src={mediaUrl}
            placeholder={placholderSrc}
          />
        );
      case "video":
        if (mediaUrl) {
          return (
            <VideoPlayer
              autoplay={videoAutoplay}
              controls={videoControls}
              className="video-js video-content mb-3"
              sources={[
                {
                  src: mediaUrl,
                  type: videoType,
                },
              ]}
              style={{ width: "100%", borderRadius: "0px", ...mediaStyles }}
            />
          );
        }
        if (!mediaUrl && placholderSrc) {
          return (
            <img
              alt={altText}
              style={{ maxWidth: "100%", ...mediaStyles }}
              src={placholderSrc}
            />
          );
        }
      case "file":
      case "3dModel":
      case "usdzModel":
        if (mediaUrl) {
          return (
            <ReactImage
              alt={altText}
              style={{ maxWidth: "100%", ...mediaStyles }}
              src={undefined}
              placeholder={placholderSrc}
            />
          );
        }
      default:
        return (
          <ReactImage
            alt={altText}
            style={{ maxWidth: "100%", ...mediaStyles }}
            src={mediaUrl}
            placeholder={placholderSrc}
          />
        );
    }
  };
  return <>{renderMedia()}</>;
}

export default RenderMedia;
